var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMarineLantern3Nm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2078,
    height: 2079,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 251,
    y: -2252,
    width: 2078,
    height: 2079
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-251 2252)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 251,
    y: -2252,
    width: 2078,
    height: 2079,
    fill: "#4472C4",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("rect", {
    x: 582,
    y: -2095,
    width: 1571,
    height: 1571,
    fill: "#FFFFFF",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1933.08-1208.43C1931.03-853.259 1641.43-567.001 1286.26-569.059 931.084-571.117 644.827-860.71 646.884-1215.88 648.936-1570.11 937.043-1855.98 1291.27-1855.27L1290.86-1648.41C1049.93-1648.89 854.22-1453.96 853.738-1213.03 853.256-972.099 1048.18-776.393 1289.11-775.911 1529.4-775.431 1724.83-969.348 1726.22-1209.63Z",
    fill: "#FFEA01",
    fillRule: "evenodd"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarineLantern3Nm);
export default __webpack_public_path__ + "static/media/MarineLantern3NM.eef87ee00e01ede2b8c60cef8c6a2d14.svg";
export { ForwardRef as ReactComponent };